module.exports = __webpack_public_path__ + "img/aiIcon-ttr.e88d7f3f.svg";